import { doc, getDoc, setDoc } from 'firebase/firestore';
import { firestore } from '../firebase/config';

// Interface for contact information
export interface ContactInfo {
  email: string;
  phone: string;
  address: string;
  hours?: string;
  socialMedia?: {
    facebook?: string;
    instagram?: string;
    twitter?: string;
    linkedin?: string;
    youtube?: string;
  };
}

// Default contact information
export const defaultContactInfo: ContactInfo = {
  email: 'info@paragonlivedesign.com',
  phone: '(555) 123-4567',
  address: '123 Main St, Anytown, USA 12345',
  hours: 'Monday-Friday: 9am-5pm, Weekend: Closed',
  socialMedia: {
    facebook: '',
    instagram: '',
    twitter: '',
    linkedin: '',
    youtube: ''
  }
};

// Contact service
export const contactService = {
  async getContactInfo(): Promise<ContactInfo> {
    try {
      const contactDoc = doc(firestore, 'contact', 'info');
      const snapshot = await getDoc(contactDoc);
      
      if (snapshot.exists()) {
        return snapshot.data() as ContactInfo;
      } else {
        console.log('No contact information found, using defaults');
        // If no contact info exists, create it with defaults
        await this.updateContactInfo(defaultContactInfo);
        return defaultContactInfo;
      }
    } catch (error) {
      console.error('Error fetching contact information:', error);
      return defaultContactInfo;
    }
  },
  
  async updateContactInfo(contactInfo: ContactInfo): Promise<ContactInfo> {
    try {
      const contactDoc = doc(firestore, 'contact', 'info');
      await setDoc(contactDoc, contactInfo);
      return contactInfo;
    } catch (error) {
      console.error('Error updating contact information:', error);
      throw error;
    }
  },
}; 